
import saMessages from '../locales/it_IT';

const itLang = {
    messages: {
        ...saMessages
    },
    locale: 'it-it',

};

export default itLang;